// hooks/useGridQuery.js
import { useQuery } from '@tanstack/react-query';
import {fetchPublicMRTData} from '../api/PublicMrtApi';

export const useInspectionGridQuery = ({
  queryKey,
  endpoint,
  params,
  enabled = true,
}) => {
  return useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      fetchPublicMRTData(endpoint, params, signal),
    enabled,
    keepPreviousData: true,
    staleTime: 30_000,
    throwOnError: true,
  });
};